import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
export function useFormatNumber(options) {
  const $ = _c(5);
  const locale = useLocale();
  let t0;
  if ($[0] !== locale || $[1] !== options) {
    t0 = new Intl.NumberFormat(locale, {
      notation: "compact",
      ...options
    });
    $[0] = locale;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const formatter = t0;
  let t1;
  if ($[3] !== formatter) {
    t1 = number => formatter.format(number);
    $[3] = formatter;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}